export const isNullOrEmpty: (str:string | undefined | null) => boolean = (str) => {
    return str === null || str === undefined || str.trim() === ''
}
export const isCuitValid = (cuit: string): boolean => {
    const regexCuit = /^(20|23|27|30|33)([0-9]{9}|-[0-9]{8}-[0-9]{1})$/g;
    return !regexCuit.test(cuit);
}

export const isObjectEmpty = (objectName:object) => {
    return JSON.stringify(objectName) === "{}";
  };